import * as Sentry from '@sentry/react';
import * as React from 'react';

interface ErrorBoundaryProps {
  fallbackComponent: React.ComponentType<{ error: unknown }>;
}

/**
 * Error boundary to catch errors during rendering
 *
 * Based on https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
 */
export class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state: { error: unknown } = { error: null };

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, { extra: { errorInfo } });
  }

  render() {
    const { error } = this.state;

    if (error) {
      const { fallbackComponent: Component } = this.props;

      return <Component error={error} />;
    }

    return this.props.children;
  }
}
